// extracted by mini-css-extract-plugin
export default {"root":"e-wallets_root__8eVFj","wrapper":"e-wallets_wrapper__O2hX6","item":"e-wallets_item__dA175","imageWrapper":"e-wallets_imageWrapper__TubGK"};